import { Header, Button, Logo, Text } from 'src/Components'
import { FormattedMessage, defineMessages, useIntl } from 'react-intl'
import AgentDropdown from '../AgentDropdown'
import styles from './MobileHeader.module.scss'
import classNames from 'classnames'
import { setMobileNavIsOpen } from 'src/store/slices/navbar'
import { useDispatch } from 'react-redux'

export interface MobileHeaderProps {
  enableAgentDropdown?: boolean
}

export const MobileHeader = ({
  enableAgentDropdown,
  ...restProps
}: MobileHeaderProps) => {
  const dispatch = useDispatch()
  const intl = useIntl()

  const translations = defineMessages({
    label: {
      id: 'MobileHeaderModalHeader.open.button.ariaLabel',
      defaultMessage: 'Open Mobile Navbar Modal',
    },
  })

  return (
    <Header className={styles.header} {...restProps}>
      <Header.Content>
        <div className={classNames(styles.col, styles.logo)}>
          <Logo />
        </div>
        <div className={styles.buttonWrapper}>
          <Button
            aria-label={intl.formatMessage(translations.label)}
            onClick={() => dispatch(setMobileNavIsOpen(true))}
            minimal
            className={styles.button}
          >
            <Text
              element='span'
              variant='secondary'
              variantCount='600'
              weight='semibold'
            >
              <FormattedMessage
                id='MobileHeader.header.btn'
                defaultMessage='Menu'
              />
            </Text>
          </Button>
        </div>
        <div className={classNames(styles.col, styles.dropdown)}>
          {enableAgentDropdown && <AgentDropdown />}
        </div>
      </Header.Content>
    </Header>
  )
}
